import React, { useContext } from 'react'
import './index.scss'
import SongwriterRegistrationHeader from '@Scenes/SongwriterRegistrationScene/SongwriterRegistrationHeader'
import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { CreateSongwriterType, createSongwriterFormSchema } from '@Entities/schemas/songwriter/create-songwriter'
import Navigation from '@App/navigation'
import { StoresContext } from '@App/contexts'
import { createSongwriter } from '@App/api/routes/songwriter/songwriter'
import { useNavigate } from 'react-router'
import convertEmptyValuesToUndefined from '@App/forms/v2/helpers/convert-empty-values-to-undefined'
import { CreateSongwriterPayload } from '@Entities/songwriter/create-songwriter-payload'
import SongwriterRegistrationForm from '@Scenes/SongwriterRegistrationScene/SongwriterRegistrationForm'

const SongwriterRegistrationScene = () => {
    const navigate = useNavigate()
    const { userStore, preloaderStore, popupStore } = useContext(StoresContext)

    const methods = useForm<CreateSongwriterType>({
        mode: 'onChange',
        criteriaMode: 'all',
        reValidateMode: 'onChange',
        delayError: 750,
        resolver: zodResolver(createSongwriterFormSchema),
        defaultValues: {},
    })

    const onSubmit = async (data: CreateSongwriterPayload) => {
        data = convertEmptyValuesToUndefined(data, true)
        preloaderStore.openTransparentPreloader(true)
        try {
            await createSongwriter(data).then((newSongwriter) => {
                userStore.changeUserSetting('showWelcomePopup', false)
                navigate(Navigation.songwriter.catalogBuilder(newSongwriter.data.id))
            })
        } catch (e) {
            popupStore.setAlertFromError(e)
        } finally {
            preloaderStore.openTransparentPreloader(false)
        }
    }

    return (
        <>
            <title>Songwriter registration</title>
            <main className="create-songwriter-scene">
                <div className="global-container">
                    <div className="songwriter-registration-scene-wrapper">
                        <SongwriterRegistrationHeader />
                        <SongwriterRegistrationForm methods={methods} onSubmit={(data) => onSubmit(data)} />
                    </div>
                </div>
            </main>
        </>
    )
}
export default SongwriterRegistrationScene
